export function createFeatureManagementClient(transport) {
    return {
        /**
         * POST /internal/v1/tenants/{tenantId}/features/{flagKey}/versions
         *
         * Requires scope: feature-management:publish
         */
        publishFeatureVersion(tenantId, flagKey, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/features/${encodeURIComponent(flagKey)}/versions`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/features/{flagKey}
         *
         * Requires scope: feature-management:read
         */
        getCurrentFeature(tenantId, flagKey, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/features/${encodeURIComponent(flagKey)}`,
                options,
            });
        },
        /**
         * List this tenant's feature flags, newest version of each, as a summary
         *
         * Requires scope: feature-management:summary:read
         */
        listTenantFeatureSummaries(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/features",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * List every tenant's feature flags, newest version of each, as a summary
         *
         * Requires scope: feature-management:platform:read
         */
        listPlatformFeatureSummaries(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/features",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/features/{flagKey}/evaluations
         *
         * Requires scope: feature-management:evaluate
         */
        evaluateFeature(tenantId, flagKey, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/features/${encodeURIComponent(flagKey)}/evaluations`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/features/{flagKey}/kill-switch
         *
         * Requires scope: feature-management:kill-switch
         */
        setFeatureKillSwitch(tenantId, flagKey, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/features/${encodeURIComponent(flagKey)}/kill-switch`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=feature-management.js.map